import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        logo: {
            display: 'flex',
            marginBottom: 30,
            marginTop: 30,
        },
        menuButton: {
            marginRight: 10,
            marginTop: 10,
        },
        hide: {
            display: 'none',
        },
        navHead: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            paddingBottom: 0,
        },
        leftChevron: {
            fontSize: '2rem',
        },
    }),
);
